import { render, staticRenderFns } from "./TRowTotem.vue?vue&type=template&id=4a644ef6"
import script from "./TRowTotem.vue?vue&type=script&lang=js"
export * from "./TRowTotem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports